import type { ReportEventDraft } from '@/types/report';
import { SelectedEventRow } from './SelectedEventRow';

interface AddEventsToReportSidebarProps {
    drafts: ReportEventDraft[];
    selectedEventId: string;
    validationVisible: boolean;
    onSelect: (eventId: string) => void;
    onRemove: (eventId: string) => void;
}

export function AddEventsToReportSidebar({
    drafts,
    selectedEventId,
    validationVisible,
    onSelect,
    onRemove,
}: AddEventsToReportSidebarProps) {
    const canRemove = drafts.length > 1;

    return (
        <div className="flex w-[312px] shrink-0 flex-col overflow-y-auto px-6 pt-6 scrollbar-hover-thumb">
            {drafts.map((draft) => (
                <SelectedEventRow
                    key={draft.event.id}
                    draft={draft}
                    isActive={draft.event.id === selectedEventId}
                    showError={validationVisible && !draft.promptText.trim()}
                    canRemove={canRemove}
                    onSelect={() => onSelect(draft.event.id)}
                    onRemove={() => onRemove(draft.event.id)}
                />
            ))}
        </div>
    );
}
